export enum MembershipRole {
  Admin = 'admin',
  Eventmanager = 'eventmanager',
  Expert = 'collaborator',
  CheckIn = 'checkin'
}
